import React from 'react'

import FullPageTemplate from '../../../components/templates/FullPageTemplate'
import PageContent from './PageContent'
import DynamicServiceOrderLoader from './_load/DynamicServiceOrderLoader'

const SuccessfullyExecutedDynamicServiceOrderPage = ({ shareCode }) => {
  return (
    <FullPageTemplate>
      <DynamicServiceOrderLoader shareCode={shareCode}>
        <PageContent />
      </DynamicServiceOrderLoader>
    </FullPageTemplate>
  )
}

export default SuccessfullyExecutedDynamicServiceOrderPage
